import type { Module } from 'vuex';
import { GlobalPair } from '@/types/GlobalPair';
import {RootState} from "@/store";

export interface GlobalPairsState {
  globalPairs: GlobalPair[];
}

const globalPairsModule: Module<GlobalPairsState, RootState> = {
  namespaced: true,

  state: (): GlobalPairsState => ({
    globalPairs: [],
  }),

  getters: {
    getById: (state) => (idGlobalPair: number): GlobalPair | undefined => {
      return state.globalPairs.find(globalPair => globalPair.idGlobalPair === idGlobalPair);
    },
  },

  mutations: {
    setGlobalPairs(
      state,
      payload: { globalPairs: Record<number, any> }
    ) {
      state.globalPairs = Object
        .values(payload.globalPairs)
        .map(raw => GlobalPair.fromRaw(raw));
    },

    setGlobalPairCreate(
      state,
      payload: {
        idGlobalPair: number;
        idCurrency: number;
        idGlobalCurrency: number;
        showOnMainPage?: boolean;
        useInQuantfury?: boolean;
        locked?: boolean;
        offset?: number;
      }
    ) {
      const raw = {
        idGlobalPair: payload.idGlobalPair,
        idCurrency: payload.idCurrency,
        idGlobalCurrency: payload.idGlobalCurrency,
        showOnMainPage: payload.showOnMainPage ?? false,
        useInQuantfury: payload.useInQuantfury ?? false,
        locked: payload.locked ?? false,
        offset: payload.offset ?? 0,
      };
      state.globalPairs.push(GlobalPair.fromRaw(raw));
    },

    setGlobalPairUpdate(
      state,
      payload: {
        idGlobalPair: number;
        showOnMainPage?: boolean;
        useInQuantfury?: boolean;
        locked?: boolean;
      }
    ) {
      const globalPair = state.globalPairs.find(globalPair => globalPair.idGlobalPair === payload.idGlobalPair);
      if (!globalPair) return;
      if (payload.showOnMainPage !== undefined) globalPair.showOnMainPage = payload.showOnMainPage;
      if (payload.useInQuantfury !== undefined) globalPair.useInQuantfury = payload.useInQuantfury;
      if (payload.locked !== undefined) globalPair.locked = payload.locked;
    },

    setGlobalPairDelete(
      state,
      payload: { idGlobalPair: number }
    ) {
      state.globalPairs = state.globalPairs.filter(
        globalPair => globalPair.idGlobalPair !== payload.idGlobalPair
      );
    },

    setGlobalPairLock(
      state,
      payload: { idGlobalPair: number }
    ) {
      const globalPair = state.globalPairs.find(globalPair => globalPair.idGlobalPair === payload.idGlobalPair);
      if (globalPair) globalPair.locked = true;
    },

    setGlobalPairUnlock(
      state,
      payload: { idGlobalPair: number }
    ) {
      const globalPair = state.globalPairs.find(globalPair => globalPair.idGlobalPair === payload.idGlobalPair);
      if (globalPair) globalPair.locked = false;
    },
  },

  actions: {
    wsSetGlobalPairs({ commit }, payload) {
      commit('setGlobalPairs', payload);
    },
    wsGlobalPairCreate({ commit }, payload) {
      commit('setGlobalPairCreate', payload);
    },
    wsGlobalPairUpdate({ commit }, payload) {
      commit('setGlobalPairUpdate', payload);
    },
    wsGlobalPairDelete({ commit }, payload) {
      commit('setGlobalPairDelete', payload);
    },
    wsGlobalPairLock({ commit }, payload) {
      commit('setGlobalPairLock', payload);
    },
    wsGlobalPairUnlock({ commit }, payload) {
      commit('setGlobalPairUnlock', payload);
    },
  },
};

export default globalPairsModule; 